import { render } from "./HospitalizationPage.vue?vue&type=template&id=39d02044"
import script from "./HospitalizationPage.vue?vue&type=script&lang=js"
export * from "./HospitalizationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__